class Toolbar extends HTMLElement {
    constructor() {
        super();
        this.queryParams();
        this.closeModalClick();

        window.list = {
            '2020_year': [
                {
                    img: 'S41-2020-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/wqry',
                    title: 'KangarooIsland',
                    subtitle: '2020 Spring',
                    seasons: 'Spring',
                    city: 'kangarooIsland',
                    tag: 'Stop41'
                },
                {
                    img: 'S42-2020-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/acjh',
                    title: 'KangarooIsland',
                    subtitle: '2020 Summer',
                    seasons: 'Summer',
                    city: 'kangarooIsland',
                    tag: 'Stop42'
                },
                {
                    img: 'S43-2020-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/aqqn',
                    title: 'KangarooIsland',
                    subtitle: '2020 Autumn',
                    seasons: 'Autumn',
                    city: 'kangarooIsland',
                    tag: 'Stop43'
                },
                {
                    img: 'S44-2020-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/jffq',
                    title: 'KangarooIsland',
                    subtitle: '2019 Winter',
                    seasons: 'Winter',
                    city: 'kangarooIsland',
                    tag: 'Stop44'
                }
            ],
            '2019_year': [
                {
                    img: 'S39-2019-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/dkxh',
                    title: 'KangarooIsland',
                    subtitle: '2019 Spring',
                    seasons: 'Spring',
                    city: 'kangarooIsland',
                    tag: 'Stop39'
                },
                {
                    img: 'S40-2019-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/nqqb',
                    title: 'KangarooIsland',
                    subtitle: '2019 Winter',
                    seasons: 'Winter',
                    city: 'kangarooIsland',
                    tag: 'Stop40'
                }
            ],
            '2018_year': [
                {
                    img: 'S37-2018-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/fqyw',
                    title: 'KangarooIsland',
                    subtitle: '2018 Spring',
                    seasons: 'Spring',
                    city: 'kangarooIsland',
                    tag: 'Stop37'
                },
                {
                    img: 'S38-2018-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/mrkq',
                    title: 'KangarooIsland',
                    subtitle: '2018 Autumn',
                    seasons: 'Autumn',
                    city: 'kangarooIsland',
                    tag: 'Stop38'
                }
            ],
            '2017_year': [
                {
                    img: 'S35-2017-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/efxh',
                    title: 'Kenya',
                    subtitle: '2017 Spring',
                    seasons: 'Spring',
                    city: 'kenya',
                    tag: 'Stop35'
                },
                {
                    img: 'S35-2017-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/wcrd',
                    title: 'Kenya',
                    subtitle: '2017 Summer',
                    seasons: 'Summer',
                    city: 'kenya',
                    tag: 'Stop35'
                },
                {
                    img: 'S36-2017-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/dsit',
                    title: 'Iceland',
                    subtitle: '2017 Autumn',
                    seasons: 'Autumn',
                    city: 'iceland',
                    tag: 'Stop36'
                },
                {
                    img: 'S36-2017-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/bxvq',
                    title: 'Iceland',
                    subtitle: '2017 Winter',
                    seasons: 'Winter',
                    city: 'iceland',
                    tag: 'Stop36'
                }
            ],
            '2016_year': [
                {
                    img: 'S33-2016-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/vrtt',
                    title: 'Taipei China',
                    subtitle: '2016 Spring',
                    seasons: 'Spring',
                    city: 'taipei-china',
                    tag: 'Stop33'
                },
                {
                    img: 'S33-2016-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/vrtt',
                    title: 'Taipei China',
                    subtitle: '2016 Summer',
                    seasons: 'Summer',
                    city: 'taipei-china',
                    tag: 'Stop33'
                },
                {
                    img: 'S34-2016-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/dzmf',
                    title: 'Finland',
                    subtitle: '2016 Autumn',
                    seasons: 'Autumn',
                    city: 'finland',
                    tag: 'Stop34'
                },
                {
                    img: 'S34-2016-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/csuh',
                    title: 'Finland',
                    subtitle: '2016 Winter',
                    seasons: 'Winter',
                    city: 'finland',
                    tag: 'Stop34'
                }
            ],
            '2015_year': [
                {
                    img: 'S31-2015-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/slny',
                    title: 'KangarooIsland',
                    subtitle: '2015 Spring',
                    seasons: 'Spring',
                    city: 'kangarooIsland',
                    tag: 'Stop31'
                },
                {
                    img: 'S31-2015-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/wolg',
                    title: 'KangarooIsland',
                    subtitle: '2015 Summer',
                    seasons: 'Summer',
                    city: 'kangarooIsland',
                    tag: 'Stop31'
                },
                {
                    img: 'S32-2015-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/fezu',
                    title: 'London',
                    subtitle: '2015 Autumn',
                    seasons: 'Autumn',
                    city: 'london',
                    tag: 'Stop32'
                },
                {
                    img: 'S32-2015-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/xfbe',
                    title: 'Bhutan',
                    subtitle: '2015 Winter',
                    seasons: 'Winter',
                    city: 'bhutan',
                    tag: 'Stop32'
                }
            ],
            '2014_year': [
                {
                    img: 'S29-2014-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/kcwm',
                    title: 'Monte-Carlo',
                    subtitle: '2014 Spring',
                    seasons: 'Spring',
                    city: 'monte-carlo',
                    tag: 'Stop29'
                },
                {
                    img: 'S29-2014-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/oliv',
                    title: 'Monte-Carlo',
                    subtitle: '2014 Summer',
                    seasons: 'Summer',
                    city: 'monte-carlo',
                    tag: 'Stop29'
                },
                {
                    img: 'S30-2014-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/dqbu',
                    title: 'London',
                    subtitle: '2014 Autumn',
                    seasons: 'Autumn',
                    city: 'london',
                    tag: 'Stop30'
                },
                {
                    img: 'S30-2014-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/edhe',
                    title: 'London',
                    subtitle: '2014 Winter',
                    seasons: 'Winter',
                    city: 'london',
                    tag: 'Stop30'
                }
            ],
            '2013_year': [
                {
                    img: 'S27-2013-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/epsk',
                    title: 'Paris',
                    subtitle: '2013 Spring',
                    seasons: 'Spring',
                    city: 'paris',
                    tag: 'Stop27'
                },
                {
                    img: 'S27-2013-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/yuzq',
                    title: 'Paris',
                    subtitle: '2013 Summer',
                    seasons: 'Summer',
                    city: 'paris',
                    tag: 'Stop27'
                },
                {
                    img: 'S28-2013-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/slth',
                    title: 'Milan',
                    subtitle: '2013 Autumn',
                    seasons: 'Autumn',
                    city: 'milan',
                    tag: 'Stop28'
                },
                {
                    img: 'S28-2013-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/syho',
                    title: 'Milan',
                    subtitle: '2013 Winter',
                    seasons: 'Winter',
                    city: 'milan',
                    tag: 'Stop28'
                }
            ],
            '2012_year': [
                {
                    img: 'S25-2012-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/jiiv',
                    title: 'MexcioCity',
                    subtitle: '2012 Spring',
                    seasons: 'Spring',
                    city: 'MexcioCity',
                    tag: 'Stop25'
                },
                {
                    img: 'S25-2012-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/tblh',
                    title: 'MexcioCity',
                    subtitle: '2012 Summer',
                    seasons: 'Summer',
                    city: 'mexcioCity',
                    tag: 'Stop25'
                },
                {
                    img: 'S26-2012-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/juxh',
                    title: 'NewYork',
                    subtitle: '2012 Autumn',
                    seasons: 'Autumn',
                    city: 'newYork',
                    tag: 'Stop26'
                },
                {
                    img: 'S26-2012-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/zctr',
                    title: 'NewYork',
                    subtitle: '2012 Winter',
                    seasons: 'Winter',
                    city: 'newYork',
                    tag: 'Stop26'
                }
            ],
            '2011_year': [
                {
                    img: 'S23-2011-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/skyc',
                    title: 'Sicilia',
                    subtitle: '2011 Spring',
                    seasons: 'Spring',
                    city: 'sicilia',
                    tag: 'Stop23'
                },
                {
                    img: 'S23-2011-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/rewk',
                    title: 'Sicilia',
                    subtitle: '2011 Summer',
                    seasons: 'Summer',
                    city: 'sicilia',
                    tag: 'Stop23'
                }
            ],
            '2008_year': [
               {
                    img: 'S15-2008-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/cyvp',
                    title: 'Tokyo',
                    subtitle: '2008 Spring',
                    seasons: 'Spring',
                    city: 'tokyo',
                    tag: 'Stop15'
                },
                {
                    img: 'S16-2008-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/ntkd',
                    title: 'Hawaii',
                    subtitle: '2008 Summer',
                    seasons: 'Summer',
                    city: 'hawaii',
                    tag: 'Stop16'
                },
                {
                    img: 'S17-2008-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/lxlf',
                    title: 'Copenhagen',
                    subtitle: '2008 Autumn',
                    seasons: 'Autumn',
                    city: 'copenhagen',
                    tag: 'Stop26'
                },
                {
                    img: 'S18-2008-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/tprm',
                    title: 'Stockholm',
                    subtitle: '2008 Winter',
                    seasons: 'Winter',
                    city: 'stockholm',
                    tag: 'Stop26'
                }
            ],
            '2007_year': [
                {
                    img: 'S11-2007-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/kzvq',
                    title: 'Singapore',
                    subtitle: '2007 Spring',
                    seasons: 'Spring',
                    city: 'singapore',
                    tag: 'Stop25'
                },
                {
                    img: 'S12-2007-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/cvgd',
                    title: 'Bali',
                    subtitle: '2007 Summer',
                    seasons: 'Summer',
                    city: 'bali',
                    tag: 'Stop25'
                },
                {
                    img: 'S13-2007-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/nzip',
                    title: 'Netherlands',
                    subtitle: '2007 Autumn',
                    seasons: 'Autumn',
                    city: 'netherlands',
                    tag: 'Stop26'
                },
                {
                    img: 'S14-2007-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/kdgr',
                    title: 'Belgium',
                    subtitle: '2007 Winter',
                    seasons: 'Winter',
                    city: 'belgium',
                    tag: 'Stop26'
                }
            ],
            '2006_year': [
                {
                    img: 'S9-2006-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/qgka',
                    title: 'Barcelona',
                    subtitle: '2006 Spring',
                    seasons: 'Spring',
                    city: 'barcelona',
                    tag: 'Stop25'
                },
                {
                    img: 'S9-2006-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/dmls',
                    title: 'Sevilla',
                    subtitle: '2006 Summer',
                    seasons: 'Summer',
                    city: 'sevilla',
                    tag: 'Stop25'
                },
                {
                    img: 'S10-2006-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/cxra',
                    title: 'Venice',
                    subtitle: '2006 Autumn',
                    seasons: 'Autumn',
                    city: 'venice',
                    tag: 'Stop26'
                },
                {
                    img: 'S10-2006-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/eehf',
                    title: 'Venice',
                    subtitle: '2006 Winter',
                    seasons: 'Winter',
                    city: 'venice',
                    tag: 'Stop26'
                }
            ],
            '2005_year': [
                {
                    img: 'S7-2005-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/uaev',
                    title: 'SouthernFrance',
                    subtitle: '2005 Spring',
                    seasons: 'Spring',
                    city: 'southernFrance',
                    tag: 'Stop7'
                },
                {
                    img: 'S8-2005-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/quwf',
                    title: 'Cambridge',
                    subtitle: '2005 Autumn',
                    seasons: 'Autumn',
                    city: 'cambridge',
                    tag: 'Stop8'
                }
            ],
            '2004_year': [
                {
                    img: 'S5-2004-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/diga',
                    title: 'Greece',
                    subtitle: '2004 Summer',
                    seasons: 'Summer',
                    city: 'greece',
                    tag: 'Stop5'
                },
                {
                    img: 'S6-2004-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/ymjl',
                    title: 'Switzerland',
                    subtitle: '2004 Winter',
                    seasons: 'Winter',
                    city: 'switzerland',
                    tag: 'Stop6'
                }
            ],
            '2003_year': [
                {
                    img: 'S3-2003-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/tqrp',
                    title: 'SouthAfrica',
                    subtitle: '2003 Summer',
                    seasons: 'Summer',
                    city: 'southAfrica',
                    tag: 'Stop3'
                },
                {
                    img: 'S4-2003-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/tqrp',
                    title: 'Paris',
                    subtitle: '2003 Winter',
                    seasons: 'Winter',
                    city: 'paris',
                    tag: 'Stop4'
                }
            ],
            '2002_year': [
                {
                    img: 'S1-2002-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/vzgx',
                    title: 'Tailand',
                    subtitle: '2002 Summer',
                    year: '2002',
                    seasons: 'Summer',
                    city: 'tailand',
                    tag: 'Stop1'
                },
                {
                    img: 'S2-2002-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/yyhu',
                    title: 'Tailand',
                    subtitle: '2002 Autumn',
                    year: '2002',
                    seasons: 'Autumn',
                    city: 'tailand',
                    tag: 'Stop1'
                },
                {
                    img: 'S2-2002-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/qqns',
                    title: 'Australia',
                    subtitle: '2002 Winter',
                    seasons: 'Winter',
                    city: 'australia',
                    tag: 'Stop2'
                }
            ]
        }
        window.recoList = {
            'Fashion City Tour_': [
                {
                    img: 'S26-2012-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/zctr',
                    title: 'NewYork',
                    subtitle: '2012 Winter',
                    seasons: 'Winter',
                    city: 'newYork',
                    tag: 'Stop26'
                },
                {
                    img: 'S27-2013-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/epsk',
                    title: 'Paris',
                    subtitle: '2013 Spring',
                    seasons: 'Spring',
                    city: 'paris',
                    tag: 'Stop27'
                },
                {
                    img: 'S29-2014-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/oliv',
                    title: 'Monte-Carlo',
                    subtitle: '2014 Summer',
                    seasons: 'Summer',
                    city: 'monte-carlo',
                    tag: 'Stop29'
                },
                {
                    img: 'S30-2014-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/dqbu',
                    title: 'London',
                    subtitle: '2014 Autumn',
                    seasons: 'Autumn',
                    city: 'london',
                    tag: 'Stop30'
                },
                {
                    img: 'S27-2013-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/yuzq',
                    title: 'Paris',
                    subtitle: '2013 Summer',
                    seasons: 'Summer',
                    city: 'paris',
                    tag: 'Stop27'
                },
                {
                    img: 'S28-2013-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/slth',
                    title: 'Milan',
                    subtitle: '2013 Autumn',
                    seasons: 'Autumn',
                    city: 'milan',
                    tag: 'Stop28'
                },
                {
                    img: 'S29-2014-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/kcwm',
                    title: 'Monte-Carlo',
                    subtitle: '2014 Spring',
                    seasons: 'Spring',
                    city: 'monte-carlo',
                    tag: 'Stop29'
                },
                {
                    img: 'S30-2014-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/edhe',
                    title: 'London',
                    subtitle: '2014 Winter',
                    seasons: 'Winter',
                    city: 'london',
                    tag: 'Stop30'
                }
            ]
        }

        window.recoList1 = {
            'Tour of Nature & Civilization_': [
                {
                    img: 'S40-2019-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/nqqb',
                    title: 'KangarooIsland',
                    subtitle: '2019 Autumn',
                    seasons: 'Autumn',
                    city: 'kangarooIsland',
                    tag: 'Stop39'
                },
                {
                    img: 'S40-2019-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/nqqb',
                    title: 'KangarooIsland',
                    subtitle: '2019 Winter',
                    seasons: 'Winter',
                    city: 'kangarooIsland',
                    tag: 'Stop40'
                },
                {
                    img: 'S39-2019-Spring.jpg',
                    url: 'https://mag.goelia1995.com/books/dkxh',
                    title: 'KangarooIsland',
                    subtitle: '2019 Spring',
                    seasons: 'Spring',
                    city: 'kangarooIsland',
                    tag: 'Stop39'
                },
                {
                    img: 'S39-2019-Summer.jpg',
                    url: 'https://mag.goelia1995.com/books/dkxh',
                    title: 'KangarooIsland',
                    subtitle: '2019 Summer',
                    seasons: 'Summer',
                    city: 'kangarooIsland',
                    tag: 'Stop40'
                },
                {
                    img: 'S38-2018-Fall.jpg',
                    url: 'https://mag.goelia1995.com/books/mrkq',
                    title: 'KangarooIsland',
                    subtitle: '2018 Autumn',
                    seasons: 'Autumn',
                    city: 'kangarooIsland',
                    tag: 'Stop38'
                },
                {
                    img: 'S38-2018-Winter.jpg',
                    url: 'https://mag.goelia1995.com/books/mrkq',
                    title: 'KangarooIsland',
                    subtitle: '2018 Winter',
                    seasons: 'Winter',
                    city: 'kangarooIsland',
                    tag: 'Stop37'
                }
            ]
        }
            
        

        window.toolbar = {
            yearList: [],
            yearVal: '',
            seasonsList: [],
            seasonsVal: '',
            destinationsList: [],
            destinationsVal: '',
            swiperObj: {},
            dom: {
                yearDom: $('.toolbar-year'),
                seasonsDom: $('.toolbar-seasons'),
                destinationsDom: $('.toolbar-destinations')
            },
            init: function () {
                const S = this;
                S.yearList = [
                    { name: 'Year', value: 'all'},
                    { name: '2020', value: '2020'},
                    { name: '2019', value: '2019'},
                    { name: '2018', value: '2018'},
                    { name: '2017', value: '2017'},
                    { name: '2016', value: '2016'},
                    { name: '2015', value: '2015'},
                    { name: '2014', value: '2014'},
                    { name: '2013', value: '2013'},
                    { name: '2012', value: '2012'},
                    { name: '2011', value: '2011'},
                    { name: '2008', value: '2008'},
                    { name: '2007', value: '2007'},
                    { name: '2006', value: '2006'},
                    { name: '2005', value: '2005'},
                    { name: '2004', value: '2004'},
                    { name: '2003', value: '2003'},
                    { name: '2002', value: '2002'}
                ]
                S.getListHtml(S.yearList, S.dom.yearDom)

                S.seasonsList = [
                    { name: 'Seasons', value: 'all'},
                    { name: 'Summer', value: 'Summer'},
                    { name: 'Autumn', value: 'Autumn'},
                    { name: 'Winter', value: 'Winter'},
                    { name: 'Spring', value: 'spring'}
                ]
                S.getListHtml(S.seasonsList, S.dom.seasonsDom)

                S.destinationsList = [
                    { name: 'Destinations', value: 'all'},
                    { name: 'Tailand', value: 'tailand' },
                    { name: 'Australia', value: 'australia' },
                    { name: 'SouthAfrica', value: 'southAfrica' },
                    { name: 'Paris', value: 'paris' },
                    { name: 'Greece', value: 'greece' },
                    { name: 'Switzerland', value: 'switzerland' },
                    { name: 'SouthernFrance', value: 'southernFrance' },
                    { name: 'Cambridge', value: 'cambridge' },
                    { name: 'Barcelona', value: 'barcelona' },
                    { name: 'Sevilla', value: 'sevilla' },
                    { name: 'venice', value: 'venice' },
                    { name: 'Italy', value: 'italy' },
                    { name: 'Singapore', value: 'singapore' },
                    { name: 'Bali', value: 'bali' },
                    { name: 'Netherlands', value: 'netherlands' },
                    { name: 'Copenhagen', value: 'copenhagen' },
                    { name: 'Stockholm', value: 'stockholm' },
                    { name: 'Belgium', value: 'belgium' },
                    { name: 'Tokyo', value: 'tokyo' },
                    { name: 'Hawaii', value: 'hawaii' },
                    { name: 'Danmark', value: 'danmark' },
                    { name: 'Sweden', value: 'sweden' },
                    { name: 'Dubai', value: 'dubai' },
                    { name: 'Russia', value: 'russia' },
                    { name: 'India', value: 'india' },
                    { name: 'Czech', value: 'czech' },
                    { name: 'Sicilia', value: 'sicilia' },
                    { name: 'Edinburgh', value: 'edinburgh' },
                    { name: 'MexcioCity', value: 'mexcioCity' },
                    { name: 'NewYork', value: 'newYork' },
                    { name: 'Milan', value: 'milan' },
                    { name: 'Monte-Carlo', value: 'monte-carlo' },
                    { name: 'London', value: 'london' },
                    { name: 'KangarooIsland', value: 'kangarooIsland' },
                    { name: 'Bhutan', value: 'bhutan' },
                    { name: 'Taipei China', value: 'taipei-china' },
                    { name: 'Finland', value: 'finland' },
                    { name: 'Kenya', value: 'kenya' },
                    { name: 'Iceland', value: 'iceland' }
                ]
                S.getListHtml(S.destinationsList, S.dom.destinationsDom)
                let list = window.list;
                S.getProductHtml(list);
                S.getProductHtml(window.recoList, 'reco', 1);
                S.getProductHtml(window.recoList1, 'reco', 2);
            },
            getListHtml: function (data, dom) {
                const S = this;
                let listHtml = '';
                data.map( x => {
                    listHtml += '<li data-sort-by-item class="item">\
                        <span class="text g-translate" data-value="'+ x.value +'">\
                            '+ x.name +'\
                        </span>\
                    </li>';
                })
                dom.find('.toolbar-dropdown .dropdown-menu').html(listHtml);
                dom.find('.dropdown-menu-body').html(listHtml);
            },
            getProductHtml: function (list, type, num) {
                const S = this;
                let __Html = ''
                let imgSrc = 'https://cdn.shopifycdn.net/s/files/1/0617/0099/7296/files/';
                let viewMOre = 'https://cdn.shopify.com/s/files/1/0617/0099/7296/files/view-more.png?v=1670568333';
                let recoBtn = 'https://cdn.shopify.com/s/files/1/0617/0099/7296/files/right-s-line.png?v=1670568333';
                let btnHtml = '';
                if (type == 'reco') {
                    btnHtml = '<div class="btn1">\
                        <span class="left-btn btn">\
                            <img src="'+ recoBtn +'" alt="" />\
                        </span>\
                        <span class="right-btn btn">\
                            <img src="'+ recoBtn +'" alt="" />\
                        </span>\
                    </div>';
                }

                let leftBtn = 'https://cdn.shopify.com/s/files/1/0617/0099/7296/files/arrow-l.png?v=1670568333';
                let rightBtn = 'https://cdn.shopify.com/s/files/1/0617/0099/7296/files/arrow-r.png?v=1670568333';
                for (let k in list) {
                    let _year = k.split('_')[0];
                    let data = list[k];
                    let __ListHtml = '';
                    let hasMore = list[k].length > 2 ? '' : 'no-more';
                    list[k].length && list[k].map(x => {
                        __ListHtml += '<li class="swiper-slide">\
                            <a href="'+ x.url +'">\
                                <div class="img-box">\
                                    <img class="img" src="'+ (imgSrc + x.img) +'?v=99" alt="" />\
                                    <span class="view-more">\
                                        <img src="'+ viewMOre +'" alt="" />\
                                    </span>\
                                </div>\
                                <span class="title g-translate">'+ x.title +'</span>\
                                <span class="subtitle g-translate">'+ x.subtitle +'</span>\
                            </a>\
                        </li>';
                    })
                    if (type == 'reco' && window.innerWidth < 768) {
                        __ListHtml = '';
                        var res = [];
                        var res1 = [];
                        var res2 = [];
                        var res3 = [];
                        var res4 = [];
                        for (var index = 0; index < list[k].length; index++) {

                            if (index % 2 == 0) {
                                res.push(list[k][index])
                            } else {
                                res1.push(list[k][index])
                            }
                        }
                        for (var index = 0; index < res.length; index += 2) {
                          res2.push([res[index], res[index + 1]]);
                        } 


                        for (var index = 0; index < res1.length; index += 2) {
                          res3.push([res1[index], res1[index + 1]]);
                        } 
                        res2.map((x,i) => {
                            res4.push(res2[i]);
                            res4.push(res3[i]);
                        })
                        hasMore = res4.length > 2 ? '' : 'no-more';
                        res4.length && res4.map(x => {
                            let _listA = '';

                            x && x.length && x.map(item => {
                                if (item) {
                                    _listA += '<a href="'+ item.url +'">\
                                        <div class="img-box">\
                                            <img class="img" src="'+ (imgSrc + item.img) +'?v=99" alt="" />\
                                            <span class="view-more">\
                                                <img src="'+ viewMOre +'" alt="" />\
                                            </span>\
                                        </div>\
                                        <span class="title g-translate">'+ item.title +'</span>\
                                        <span class="subtitle g-translate">'+ item.subtitle +'</span>\
                                    </a>';
                                }
                            })
                            __ListHtml += '<li class="swiper-slide">'+ _listA +'</li>';
                        })
                    }
                    
                    if (__ListHtml) {
                        __Html += '<div class="imgs-item">\
                            <div class="head '+ hasMore +'">\
                                <h2 class="g-translate">'+ _year +'</h2>\
                                <div class="view-more-btn">\
                                    <span class="left-btn btn">\
                                        <img class="disabled" src="'+ leftBtn +'" alt="" />\
                                        <img class="default" src="'+ rightBtn +'" alt="" />\
                                    </span>\
                                    <span class="right-btn btn">\
                                        <img class="disabled" src="'+ leftBtn +'" alt="" />\
                                        <img class="default" src="'+ rightBtn +'" alt="" />\
                                    </span>\
                                </div>\
                            </div>\
                            '+ btnHtml +'\
                            <div class="body swiper-container">\
                                <ul class="swiper-wrapper">'+ __ListHtml +'</ul>\
                            </div>\
                        </div>';
                    }
                }
                if (__Html) {
                    type == 'reco' ? $('.recommend-box' + num).find('.imgs-content').html(__Html) : $('.year-list .imgs-content').html(__Html);
                } else {
                    let noHtml = '<div class="no-data">No data</div>'
                    $('.year-list .imgs-content').html(noHtml);
                }

                if(window.innerWidth < 768) {
                    if ($('.year-list').length && type != 'reco') {
                        for (let k in S.swiperObj) {
                            S.swiperObj[k].destroy();
                        }
                        // 轮播处理
                        $('.year-list .imgs-item').each(function (i, item) {
                            let obj = $(this)

                            let o = $(this).find('.body');

                            // if (o.find('li').length > 2) {
                            S.swiperObj[i] = new Swiper(o, {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                                loop : false,
                                spaceBetween: 15,
                                navigation: {
                                    nextEl: obj.find('.right-btn'),
                                    prevEl: obj.find('.left-btn')
                                },
                                on: {
                                    init: function(){
                                        obj.find('.left-btn').addClass('swiper-button-disabled')
                                    },
                                    slideChange: function(){
                                      console.log('改变了，activeIndex为' + this.activeIndex);
                                    }
                                }
                            });
                            // }

                        })
                    } else {
                        $('.recommend-box').each(function() {
                            var o = $(this);
                            let recoDom = $(this).find('.body');
                            new Swiper(recoDom, {
                                slidesPerView: 2,
                                slidesPerGroup: 2,
                                loop : false,
                                spaceBetween: 15,
                                navigation: {
                                    nextEl: o.find('.right-btn'),
                                    prevEl: o.find('.left-btn')
                                },
                                on: {
                                    init: function(){
                                        o.find('.left-btn').addClass('swiper-button-disabled')
                                    },
                                    slideChange: function(){
                                      console.log('改变了，activeIndex为' + this.activeIndex);
                                    }
                                }
                            });
                        })
                    }
                } else {
                    $('.recommend-box').each(function() {
                        var o = $(this);
                        console.log(o, 555)
                        let recoDom = o.find('.body');
                        new Swiper(recoDom, {
                            slidesPerView: 4,
                            slidesPerGroup: 4,
                            loop : false,
                            spaceBetween: '6%',
                            navigation: {
                                nextEl: o.find('.right-btn'),
                                prevEl: o.find('.left-btn')
                            },
                            on: {
                                init: function(){
                                    o.find('.left-btn').addClass('swiper-button-disabled')
                                },
                                slideChange: function(){
                                  console.log('改变了，activeIndex为' + this.activeIndex);
                                }
                            }
                        });
                    })
                }
            }
        }
        this.toolbar = toolbar;
        toolbar.init();

        if(this.querySelector('[data-view-as]')){
            this.mediaView = this.querySelector('[data-view-as]');
            this.mediaViewMobile = this.querySelector('[data-view-as-mobile]');

            this.mediaView.querySelectorAll('.icon-mode').forEach((modeButton) => {
                modeButton.addEventListener('click', this.onClickModeButtonHandler.bind(this));
            });

            this.mediaViewMobile.querySelectorAll('.icon-mode').forEach((modeMobileButton) => {
                modeMobileButton.addEventListener('click', this.onClickModeButtonMobileHandler.bind(this));
            });

            this.debouncedOnResizeMediaQuery = debounce(() => {
                this.setActiveViewModeMediaQuery(false);
            }, 200);

            var w = window.innerWidth;

            window.addEventListener('resize', () => {
                if (window.innerWidth == w) {
                    return 
                }

                w = window.innerWidth;

                this.debouncedOnResizeMediaQuery();
            });

            window.addEventListener('load', () => {
                this.debouncedOnResizeMediaQuery();
            });
        }

        if(this.querySelector('[data-limited-view]')){
            this.limitView = this.querySelector('[data-limited-view]');

            this.limitView.querySelectorAll('[data-limited-view-item]').forEach((limitButton) => {
                limitButton.addEventListener('click', this.onClickLimitButtonHandler.bind(this));
            });
        }

        if(this.querySelector('[data-toggle]')){
            this.querySelectorAll('[data-toggle]').forEach((dropdownButton) => {
                dropdownButton.addEventListener('click', this.onClickDropdownButtonHandler.bind(this));
            });

            document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
        }
        $('.toolbar-wrapper [data-sort-by-item], .toolbar [data-sort-by-item]').click((e) => {
            this.onClickSortByButtonHandler(e)
        })
        $(document).on('click', '.background-overlay', (e) => {
            $('body').removeClass('toolbar-modal-open')
            $('.toolbar').removeClass('open');
            $('[data-toggle]').attr('aria-expanded', false);
        })

        // $(document).on('click.toolbaritem', '.toolbar-wrapper [data-sort-by-item]', (e) => {
        //     this.onClickSortByButtonHandler(e)
        // })

        if(this.checkNeedToConvertCurrency()){
            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
        }
    }

    queryParams() {
        Shopify.queryParams = {};

        if (location.search.length > 0) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');

                if (aKeyValue.length > 1) {
                    Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }
    }

    createURLHash(baseLink) {
        var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');

        if (baseLink) {
            if (newQuery != "") {
                return baseLink + "?" + newQuery;
            } else {
                return baseLink;
            }
        } else {
            if (newQuery != "") {
                return location.pathname + "?" + newQuery;
            } else {
                return location.pathname;
            }
        }
    }

    updateURLHash(baseLink) {
        delete Shopify.queryParams.page;

        var newUrl = this.createURLHash(baseLink);

        history.pushState({
            param: Shopify.queryParams
        }, newUrl, newUrl);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }

    onClickDropdownButtonHandler(event) {
        var buttonElement = event.currentTarget;
        if (buttonElement.dataset.mobile === 'mobile') {
            $(buttonElement).closest('.toolbar').addClass('open').siblings('.toolbar').removeClass('open');
            // const mobileSortDropdownMenu = this.querySelector('[data-sorting][data-mobile]')
            $('body').addClass('toolbar-modal-open')
        }

        if (buttonElement.getAttribute('aria-expanded') === 'false'){
            buttonElement.setAttribute('aria-expanded', true);
        } else {
            buttonElement.setAttribute('aria-expanded', false);
        }
    }

    onClickSortByButtonHandler(event) {
        console.log(555)
        event.preventDefault();

        var buttonElement = event.currentTarget;
        this.sortBy = buttonElement.closest('[data-sorting]')

        if (!buttonElement.classList.contains('is-active')) {
            var value = buttonElement.querySelector('.text').getAttribute('data-value'),
                href = buttonElement.querySelector('.text').getAttribute('data-href'),
                text = buttonElement.querySelector('.text').innerText;

            if (this.sortBy.querySelector('.label-text') != null) {
                this.sortBy.querySelector('.label-text').innerText = text;
            }

            if (this.sortBy.querySelector('[data-toggle]') != null) {
                this.sortBy.querySelector('[data-toggle]')?.setAttribute('aria-expanded', false);
            }

            this.sortBy.querySelectorAll('[data-sort-by-item]').forEach((sortByButton) => {
                sortByButton.classList.remove('is-active');
            });

            buttonElement.classList.add('is-active');

            if (this.sortBy.dataset.mobile === 'mobile') {
                const dropdownButton = this.querySelector('[data-toggle][data-mobile="mobile"]')
                dropdownButton.setAttribute('aria-expanded', false);
                $(buttonElement).closest('.toolbar').removeClass('open').find('.mobile-text').html(text)
                document.body.classList.remove('toolbar-modal-open');

                if ($('.toolbar-box').hasClass('show-sticky')) {
                    let _top = $('#main-collection-product-grid').offset().top - 150
                    $(window).scrollTop(_top)
                }
            }
            $(buttonElement).parents('.toolbar-year').length && (toolbar.yearVal = value);
            $(buttonElement).parents('.toolbar-seasons').length && (toolbar.seasonsVal = value);
            $(buttonElement).parents('.toolbar-destinations').length && (toolbar.destinationsVal = value);

            let data = JSON.parse(JSON.stringify(window.list));
            for (let k in data) {
                let _year = k.split('_')[0];
                if (_year == toolbar.yearVal) {
                    let list = data[k]
                    data = {}
                    data[k] = list;
                }

                if (toolbar.seasonsVal && toolbar.seasonsVal != 'all') {
                    for (let i in data) {
                        data[i] && data[i].length && data[i].map( (x, index) => {
                            if (x.seasons != toolbar.seasonsVal) {
                                data[i].splice(index, 1)
                            }
                        })
                    }
                }
                if (toolbar.destinationsVal && toolbar.destinationsVal != 'all') {
                    for (let i in data) {
                        data[i] && data[i].length && data[i].map( (x, index) => {
                            if (x.city != toolbar.destinationsVal) {
                                data[i].splice(index, 1)
                            }
                        })
                    }
                }
            }
            let __data = {}
            for (let i in data) {
                data[i] && (__data[i] = data[i])
            }
            toolbar.getProductHtml(__data)
            
            
            if(window.show_storefront_filter) {
                const form = document.querySelector('collection-filters-form');
                    form.querySelector('[name="sort_by"]').value = href;
                    form.onSubmitHandlerFromSortBy(event, form.querySelector('form'));
            } else {
                // Shopify.queryParams.sort_by = href;
                // this.updateURLHash();

                // var newUrl = this.createURLHash();
                // this.renderPage(newUrl);
            }
        }
    }

    getSections() {
        return [
            {
                id: 'main-collection-product-grid',
                section: document.getElementById('main-collection-product-grid').dataset.id,
            }
        ]
    }

    renderPage(href) {
        const sections = this.getSections();

        // document.getElementById('CollectionProductGrid').querySelector('.collection').classList.add('is-loading');
        document.body.classList.add('has-halo-loader');

        sections.forEach((section) => {
            this.renderSectionFromFetch(href, section);
        });
    }

    renderSectionFromFetch(url, section) {
        fetch(url)
        .then(response => response.text())
        .then((responseText) => {
            const html = responseText;

            this.renderSidebar(html);
            this.renderProductGrid(html);
        });
    }

    renderSidebar(html) {
        if(document.getElementById('main-collection-filters')){
            const innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('main-collection-filters').innerHTML;

            document.getElementById('main-collection-filters').innerHTML = innerHTML;
        }
    }

    renderProductGrid(html) {
        const innerHTML = new DOMParser()
                            .parseFromString(html, 'text/html')
                            .getElementById('main-collection-product-grid').innerHTML;

        document.getElementById('main-collection-product-grid').innerHTML = innerHTML;

        this.setActiveViewModeMediaQuery(true);

        if(window.compare.show){
            this.setLocalStorageProductForCompare({
                link: $('a[data-compare-link]'),
                onComplete: null
            });
        }

        if(window.wishlist.show){
            this.setLocalStorageProductForWishlist();
        }

        if(window.innerWidth < 1025){
            // document.getElementById('CollectionProductGrid').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
            window.scrollTo({
                top: document.getElementById('main-collection-product-grid').getBoundingClientRect().top + window.pageYOffset - 50,
                behavior: 'smooth'
            });
        }

        document.body.classList.remove('has-halo-loader');
    }

    setLocalStorageProductForCompare($link) {
        var count = JSON.parse(localStorage.getItem('compareItem')),
            items = $('[data-product-compare-handle]');

        if(count !== null){ 
            if(items.length > 0) {
                items.each((index, element) => {
                    var item = $(element),
                        handle = item.data('product-compare-handle');

                    if(count.indexOf(handle) >= 0) {
                        item.find('.compare-icon').addClass('is-checked');
                        item.find('.text').text(window.compare.added);
                        item.find('input').prop('checked', true);
                    } else {
                        item.find('.compare-icon').removeClass('is-checked');
                        item.find('.text').text(window.compare.add);
                        item.find('input').prop('checked', false);
                    }
                });
            }
        }
    }
  
    setLocalStorageProductForWishlist() {
        var wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
        localStorage.setItem('wishlistItem', JSON.stringify(wishlistList));

        if (wishlistList.length > 0) {
            wishlistList = JSON.parse(localStorage.getItem('wishlistItem'));
            
            wishlistList.forEach((handle) => {
                this.setProductForWishlist(handle);
            });
        }
        $('[data-wishlist-count]').text(wishlistList.length);
    }

    setProductForWishlist(handle){
        var wishlistList = JSON.parse(localStorage.getItem('wishlistItem')),
            item = $('[data-wishlist-handle="'+ handle +'"]'),
            index = wishlistList.indexOf(handle);
        
        if(index >= 0) {
            item
                .addClass('wishlist-added')
                .find('.text')
                .text(window.wishlist.added)
        } else {
            item
                .removeClass('wishlist-added')
                .find('.text')
                .text(window.wishlist.add);
        }
    }
  
    setActiveViewModeMediaQuery(ajaxLoading = true){
        var viewMode = this.mediaView?.querySelector('.icon-mode.active'),
            viewModeMobile = this.mediaViewMobile?.querySelector('.icon-mode.active'),
            column = parseInt(viewMode?.dataset.col),
            windowWidth = window.innerWidth;
        
        if(column != 1){
            if(document.querySelector('.sidebar--layout_vertical')){
                if (windowWidth < 768) {
                    if (column == 3 || column == 4 || column == 5) {
                        column = 2;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-2').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-2').classList.add('active');
                    }
                } else if (windowWidth <= 1100 && windowWidth >= 768) {
                    if (column == 5 || column == 4 || column == 3) {
                        column = 2;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-2').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-2').classList.add('active');
                    }
                } else if (windowWidth < 1299 && windowWidth > 1100) {
                    if (column == 5 || column == 4) {
                        column = 3;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-3').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-3').classList.add('active');
                    }
                } else if (windowWidth < 1700 && windowWidth >= 1299) {
                    if (column == 5) {
                        column = 4;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-4').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-4').classList.add('active');
                    }
                }
            } else{
                if (windowWidth < 768) {
                    if (column == 3 || column == 4 || column == 5) {
                        column = 2;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-2').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-2').classList.add('active');
                    }
                } else if (windowWidth < 992 && windowWidth >= 768) {
                    if (column == 4 || column == 5) {
                        column = 3;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-3').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-3').classList.add('active');
                    }
                } else if (windowWidth < 1600 && windowWidth >= 992) {
                    if (column == 5) {
                        column = 4;
                        viewMode.classList.remove('active');
                        viewModeMobile.classList.remove('active');
                        this.mediaView.querySelector('.grid-4').classList.add('active');
                        this.mediaViewMobile.querySelector('.grid-4').classList.add('active');
                    }
                }
            }
            
            this.initViewModeLayout(column);
        } else{
            if(ajaxLoading){
                this.initViewModeLayout(column);
            }
        }
    }
    
    changeBannerPositions(column) {
        const collectionProductGrid = document.getElementById('main-collection-product-grid')
        const productLists = [...collectionProductGrid.querySelectorAll('.product')]
        const banner1 = productLists.find(product => product.dataset.productBanner == 1)
        const banner2 = productLists.find(product => product.dataset.productBanner == 2)
        const banner3 = productLists.find(product => product.dataset.productBanner == 3)
        const bannerLists = [banner1, banner2, banner3]

        const getCurrentPosition = (banner) => {
            const currentIndex = productLists.indexOf(banner) 

            return {
                bannerNumber: banner.dataset.productBanner,
                currentIndex,
                originalIndex: parseInt(banner.dataset.firstPosition)
            }
        }

        const getNextPosition = (info) => {
            let nextPosition = info.currentIndex
            
            switch (column) {
                case 2: {
                    if (info.bannerNumber == 1) {
                        nextPosition = 2
                    } else if (info.bannerNumber == 2) {
                        nextPosition = 5
                    } else if (info.bannerNumber == 3) {
                        nextPosition = 8
                    }
                    collectionProductGrid.classList.add('banner-full-width')
                    break
                }

                case 3: {
                    if (info.bannerNumber == 3 ) {
                        nextPosition = info.originalIndex
                    } else {
                        nextPosition = info.originalIndex - 1
                    }
                    break
                } 

                case 4: {
                    nextPosition = info.originalIndex
                    break
                }

                case 5: {
                    if (info.bannerNumber == 3 ) {
                        nextPosition = info.originalIndex + 3
                    } else {
                        nextPosition = info.originalIndex + 1
                    }
                    break
                } 

                default: {
                    collectionProductGrid.classList.remove('banner-full-width')
                }
            }

            return {
                bannerNumber: info.bannerNumber,
                originalIndex: info.originalIndex,
                currentIndex: nextPosition
            }
        }

        const clearBanner = () => {
            collectionProductGrid.removeChild(banner1)
            collectionProductGrid.removeChild(banner2)
            collectionProductGrid.removeChild(banner3)
        }

        const setBannerPosition = (nextInfo) => {
            const clearedList = [...collectionProductGrid.querySelectorAll('.product')]
            let productBefore = clearedList[nextInfo.currentIndex]

            const bannerToAppend = bannerLists.find(banner => banner.dataset.productBanner == nextInfo.bannerNumber)
            collectionProductGrid.insertBefore(bannerToAppend, productBefore)
        }
        
        const bannersInfo = bannerLists.map(getCurrentPosition) 
        const bannersNextInfo = bannersInfo.map(getNextPosition)
        clearBanner()
        bannersNextInfo.forEach(setBannerPosition)
    }

    initViewModeLayout(column) {
        const productListing = document.getElementById('main-collection-product-grid');

        if (!productListing) return;

        switch (column) {
            case 1:
                productListing.classList.remove('productGrid', 'column-5', 'column-4', 'column-3', 'column-2');
                productListing.classList.add('productList');

                
                // if(document.body.classList.contains('product-card-layout-01') || document.body.classList.contains('product-card-layout-05')){
                //     if(productListing.classList.contains('productList')){
                //         const cards = productListing.querySelectorAll('.card');
                //         cards.forEach(card => {
                //             const compareInput = card.querySelector('input.compare-checkbox');
                //             compareInput.disabled = true;
                //         })
                //     }
                // }

                break;

            default:
                switch (column) {
                    case 2:
                        productListing.classList.remove('productList', 'column-5', 'column-4', 'column-3');
                        productListing.classList.add('productGrid', 'column-2');

                        break;
                    case 3:
                        productListing.classList.remove('productList', 'column-5', 'column-4', 'column-2');
                        productListing.classList.add('productGrid', 'column-3');

                        break;
                    case 4:
                        productListing.classList.remove('productList', 'column-5', 'column-3', 'column-2');
                        productListing.classList.add('productGrid', 'column-4');

                        break;
                    case 5:
                        productListing.classList.remove('productList', 'column-4', 'column-3', 'column-2');
                        productListing.classList.add('productGrid', 'column-5');

                        break;
                }
        };
        
        if (document.querySelector('.collection-masonry')) {
            resizeAllGridItems();
        }

        if (document.querySelector('.collection-banner-adv')) {
            this.changeBannerPositions(column);
        }
    }

    onClickModeButtonHandler(event){
        event.preventDefault();

        var buttonElement = event.currentTarget,
            viewMode = this.mediaView.querySelector('.icon-mode.active'),
            column = parseInt(buttonElement.dataset.col);

        if(!buttonElement.classList.contains('active')){
            viewMode.classList.remove('active');
            buttonElement.classList.add('active');

            this.mediaViewMobile.querySelectorAll('.icon-mode').forEach((element) => {
                var currentColum = parseInt(element.dataset.col);

                if(currentColum == column){
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            this.initViewModeLayout(column);
        }
    }

    onClickModeButtonMobileHandler(event){
        event.preventDefault();

        var buttonElement = event.currentTarget,
            viewMode = this.mediaViewMobile.querySelector('.icon-mode.active'),
            column = parseInt(buttonElement.dataset.col);

        if(!buttonElement.classList.contains('active')){
            viewMode.classList.remove('active');
            buttonElement.classList.add('active');

            this.mediaView.querySelectorAll('.icon-mode').forEach((element) => {
                var currentColum = parseInt(element.dataset.col);

                if(currentColum == column){
                    element.classList.add('active');
                } else {
                    element.classList.remove('active');
                }
            });

            this.initViewModeLayout(column);
        }
    }

    onClickLimitButtonHandler(event){
        event.preventDefault();

        var buttonElement = event.currentTarget;

        if(!buttonElement.classList.contains('is-active')){
            var value = parseInt(buttonElement.querySelector('.text').dataset.value);

            this.limitView.querySelector('.label-text').innerText = value;
            this.limitView.querySelector('[data-toggle]').setAttribute('aria-expanded', false);

            this.limitView.querySelectorAll('[data-limited-view-item]').forEach((limitButton) => {
                limitButton.classList.remove('is-active');
            });

            buttonElement.classList.add('is-active');

            console.log(value, 5555)
        }
    }

    connectedCallback(){
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetScroll = $('#main-collection-product-grid').offset().top + 100;

        var windowWidth = window.innerWidth;

        if (windowWidth < 1025) {
            if (scrollTop > offsetScroll) {
                requestAnimationFrame(this.showSticky.bind(this));

                if(document.body.classList.contains('scroll-up')){
                    var height = document.querySelector('sticky-header').offsetHeight;

                    this.style.top = `${height}px`;
                } else if(document.body.classList.contains('scroll-down')) {
                    this.style.top = 0;
                }
            } else{
                requestAnimationFrame(this.hideSticky.bind(this));
            }
        }

        this.currentScrollTop = scrollTop;
    }

    hideSticky() {
        // this.classList.remove('show-sticky', 'animate');
        $('.toolbar-box').removeClass('show-sticky animate')
        this.closeDropdownPopupSticky();
    }

    showSticky() {
        $('.toolbar-box').addClass('show-sticky animate')
        this.closeDropdownPopupSticky();
    }

    closeModalClick() {
        this.closeMobileModal = this.querySelector('[data-sorting][data-mobile] .close-mobile-modal')
        this.closeMobileModal.addEventListener('click', () => {
            const dropdownButton = this.querySelector('[data-toggle][data-mobile="mobile"]')
            dropdownButton.setAttribute('aria-expanded', false); 
            $(dropdownButton).closest('.toolbar').removeClass('open')
            document.body.classList.remove('toolbar-modal-open')
        })
    }

    closeDropdownPopupSticky(){
        if(this.querySelector('.label-tab')){
            this.querySelectorAll('.label-tab').forEach((element) => {
                element.setAttribute('aria-expanded', false);
            });
        }
    }   

    onBodyClickEvent(event){
        if(this.querySelector('[data-toggle]')){
            this.querySelectorAll('[data-toggle]').forEach((dropdownButton) => {
                if (dropdownButton.dataset.mobile === 'mobile') {
                    // const contentDropdown = this.querySelector('[data-sorting][data-mobile]')
                    // if ((!contentDropdown.contains(event.target)) && (!dropdownButton.contains(event.target))){
                    //     dropdownButton.setAttribute('aria-expanded', false);
                    //     if (document.body.classList.contains('toolbar-modal-open')) {
                    //         document.body.classList.remove('toolbar-modal-open')
                    //     }
                    // }
                } else {
                    var contentDropdown = dropdownButton.nextElementSibling;
                    if ((!contentDropdown.contains(event.target)) && (!dropdownButton.contains(event.target))){
                        dropdownButton.setAttribute('aria-expanded', false);
                    }
                }
            });
        }
    }
}

customElements.define('toolbar-item', Toolbar);